import {ICustomVendor as IGVLVendorInfo} from "./vendor-list";
import cmp from "../context/context";

export class CustomVendor {
    /* STATIC */
    public static build(vendorId:number) : CustomVendor|null {
        const gvlVendor: IGVLVendorInfo|undefined = cmp().vendorList?.getCustomVendorInfo(vendorId);
        if (gvlVendor) {
            return new CustomVendor(gvlVendor);
        }
        return null;
    }

    /* INSTANCE */

    protected constructor(protected readonly _gvlVendor:IGVLVendorInfo) {
    }

    public get id() : number {
        return this._gvlVendor.id;
    }

    public get name() : string {
        return this._gvlVendor.name;
    }

    public get privacyUrl() : string {
        return this._gvlVendor.privacy_url;
    }

    public get accepted() : boolean|undefined {
        if(!cmp().customConsent?.existsCustomConsentCookie())
            return undefined;
        return cmp().customConsent?.vendorsIds().includes(this.id);
    }
}
